import React from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {
  ConferenceEntryPointTypesEnum,
  ConferenceModel,
  ConferenceStatusesEnum,
  ConferenceTypesEnum,
} from '../../../src/models/api/conferenceModel';
import {getConferencingIntegrations} from '../../../src/store/data/dataSelectors';
import {createSelector} from '../reselectHelpers';

const ProviderConferenceTypes = [
  ConferenceTypesEnum.EVENT_HANGOUT,
  ConferenceTypesEnum.EVENT_NAMED_HANGOUT,
  ConferenceTypesEnum.HANGOUTS_MEET,
  ConferenceTypesEnum.SKYPE_FOR_BUSINESS,
  ConferenceTypesEnum.SKYPE_FOR_CONSUMER,
  ConferenceTypesEnum.TEAMS_FOR_BUSINESS,
  ConferenceTypesEnum.GOOGLE_ADD_ON,
];
export const isProviderConferenceType = (conferenceType: ConferenceTypesEnum) =>
  ProviderConferenceTypes.includes(conferenceType);

export const mapIntegrationTypeToConferenceType = (
  integrationType: string,
): ConferenceTypesEnum | undefined => {
  switch (integrationType) {
    case ConferenceTypesEnum.ZOOM:
      return ConferenceTypesEnum.ZOOM;
    default:
      return undefined;
  }
};

export const buildPendingConference = (conferenceType: ConferenceTypesEnum) => {
  const pendingConference: ConferenceModel = {
    type: conferenceType,
    status: ConferenceStatusesEnum.PENDING,
    id: undefined,
    name: undefined,
    description: undefined,
    entryPoints: [],
  };

  return pendingConference;
};

export const conferenceTypeToText = {
  [ConferenceTypesEnum.ZOOM]: <Trans id="conference-option-zoom">Zoom Meeting</Trans>,
  [ConferenceTypesEnum.EVENT_HANGOUT]: <Trans id="conference-option-google-hangouts">Google Hangouts</Trans>,
  [ConferenceTypesEnum.EVENT_NAMED_HANGOUT]: (
    <Trans id="conference-option-google-hangouts">Google Hangouts</Trans>
  ),
  [ConferenceTypesEnum.HANGOUTS_MEET]: <Trans id="conference-option-hangouts-meet">Google Meet</Trans>,
  [ConferenceTypesEnum.SKYPE_FOR_BUSINESS]: <Trans id="conference-option-skype">Skype</Trans>,
  [ConferenceTypesEnum.SKYPE_FOR_CONSUMER]: <Trans id="conference-option-skype">Skype</Trans>,
  [ConferenceTypesEnum.TEAMS_FOR_BUSINESS]: (
    <Trans id="conference-option-microsoft-teams">Microsoft Teams</Trans>
  ),
  [ConferenceTypesEnum.GOOGLE_ADD_ON]: <Trans id="conference-option-google-addon">Conference</Trans>,
};

export const tryFindConferenceJoinUrl = (conference: ConferenceModel) => {
  const videoEntryPoint = conference.entryPoints.find((p) => p.type === ConferenceEntryPointTypesEnum.VIDEO);
  return videoEntryPoint ? videoEntryPoint.uri : undefined;
};

export const getZoomIntegration = createSelector([getConferencingIntegrations], (conferencingIntegrations) =>
  conferencingIntegrations.find(
    (i) => mapIntegrationTypeToConferenceType(i.type) === ConferenceTypesEnum.ZOOM,
  ),
);
